import changePasswordFailure from './changePassword/failure';
import changePasswordRequest from './changePassword/request';
import changePasswordSuccess from './changePassword/success';
import forgotPasswordFailure from './forgotPassword/failure';
import forgotPasswordRequest from './forgotPassword/request';
import forgotPasswordSuccess from './forgotPassword/success';
import logoutRequest from './logout/request';
import resetPasswordFailure from './resetPassword/failure';
import resetPasswordRequest from './resetPassword/request';
import resetPasswordSuccess from './resetPassword/success';
import setProfile from './set/profile';
import signInFailure from './signIn/failure';
import signInRequest from './signIn/request';
import signInSuccess from './signIn/success';

const reducers = {
  changePasswordFailure,
  changePasswordRequest,
  changePasswordSuccess,
  forgotPasswordFailure,
  forgotPasswordRequest,
  forgotPasswordSuccess,
  logoutRequest,
  resetPasswordFailure,
  resetPasswordRequest,
  resetPasswordSuccess,
  signInFailure,
  signInRequest,
  signInSuccess,
  setProfile,
};

export default reducers;
